// This is referenced in src/themes/defaultTheme.ts
export const voicemailComponentStyles = {
  components: {
    // Style file references go here
  },
}
